import { routesPath } from '@cockpitai/constants/routesPath'
import { FallbackProps } from 'react-error-boundary'
import { Button } from '../atoms'
import ErrorIllustration from '../atoms/Illustrations/Error'
import { Typography } from '../atoms/Typography'

export function GeneralErrorApplication({
  error,
  resetErrorBoundary,
}: FallbackProps) {
  console.log('error', error)

  return (
    <div className="bg-b flex h-screen flex-col items-center justify-center">
      <ErrorIllustration />

      <div className="flex flex-col items-center justify-center space-y-4">
        <Typography type="headingThree" className="text-white/70">
          Ops
        </Typography>
        <Typography type="headingSix" className="text-white/50">
          Algo inesperado aconteceu
        </Typography>
        <div className="flex gap-4">
          <Button
            type="button"
            className="hover:scale-105"
            onClick={resetErrorBoundary}>
            Tentar novamente
          </Button>
          <a href={routesPath.dashboard.home} className="hover:scale-105">
            <Button type="button">Voltar para home</Button>
          </a>
        </div>
      </div>
    </div>
  )
}
